import { useEffect } from "react";

import { useAuthContext } from "shared/utils/hooks/useAuthContext";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

declare global {
  interface Window {
    $crisp: any[];
    CRISP_READY_TRIGGER?: () => void;
  }
}

const CrispEvents = () => {
  const { state } = useGlobalContext();
  const { loggedUser } = useAuthContext();

  const userName = loggedUser?.display_name;
  const userEmail = loggedUser?.email;
  const userPhone = loggedUser?.phone;
  const userPhoto = loggedUser?.photo;

  const platform = state?.tenancy?.uuid;

  useEffect(() => {
    const onCrispReady = () => {
      if (window.$crisp) {
        window.$crisp.push(["set", "user:nickname", [userName]]);
        window.$crisp.push(["set", "user:email", [userEmail]]);
        window.$crisp.push(["set", "user:phone", [userPhone]]);
        if (!!userPhoto)
          window.$crisp.push(["set", "user:avatar", [userPhoto]]);

        window.$crisp.push(["set", "user:company", [platform]]);
      }
    };

    window.CRISP_READY_TRIGGER = onCrispReady;

    return () => {
      window.CRISP_READY_TRIGGER = undefined;
    };
  }, []);

  return null;
};

export default CrispEvents;
